<nav class="navbar navbar-expand-sm flex-column">
  <!-- Accessibility link -->
  <div class="container-fluid d-flex w-100 header-with-tabs-for-desktop">
    <div class="w-100">
      <div class="container-fluid d-flex pe-0 header-first-row">
        <!-- Application Name -->
        <span class="navbar-app-name d-flex align-items-center">
          <!-- TotalEnergies Logo -->
          <a class="navbar-brand text-uppercase" href="#"> <img class="logo-digital-cockpit" src="assets/logo_deploy_cockpit.svg" alt="" /> </a
            >Digital Cockpit</span
            >
            <!-- Navbar content -->
            <ul class="navbar-nav ms-auto d-flex flex-row no-export header-first-row-list">
              <li class="nav-item">
                <button
                  class="btn btn-outline btn-circle position-relative"
                  [ngbPopover]="notificationMenu"
                  autoClose="outside"
                  #notificationMenuRef="ngbPopover"
                  (click)="notificationsOpened()"
                  id="notifications-button">
                  <span class="material-icons-outlined header-icon">notifications</span>
                  <span
                    class="position-absolute translate-middle badge rounded-pill notification-unopened-badge"
                    [hidden]="notificationsNotOpenedCount == 0">
                    {{ notificationsNotOpenedCount <= 99 ? notificationsNotOpenedCount : "99+" }}<span class="visually-hidden">unread messages</span>
                  </span>
                </button>
                <ng-template #notificationMenu>
                  <div class="notification-title-container">
                    <div class="notification-panel">
                      <span class="material-icons-outlined color_red" aria-hidden="true" color="accent">
                        {{ "notifications" }}
                      </span>
                      <div class="notification-title">Notifications</div>
                    </div>
                    <button type="button" class="btn-close" (click)="notificationMenuRef.close()"></button>
                  </div>
                  <div class="notification-content-container">
                    <div class="segmented-control-container">
                      <button
                        class="segmented-control-item"
                        [ngClass]="{selected: notificationDisplaySelected == 0}"
                        (click)="updateNotificationsDisplayed(0)">
                        All
                      </button>
                      <button
                        class="segmented-control-item"
                        [ngClass]="{selected: notificationDisplaySelected == 1}"
                        (click)="updateNotificationsDisplayed(1)">
                        Unread
                      </button>
                    </div>
                    <div class="notification-list">
                      @if (notifications?.length == 0) {
                        <div style="margin-left: 24px"><i>No notifications.</i></div>
                      }
                      @for (notification of notificationsToDisplay; track notification.id) {
                        <div style="margin-bottom: 8px">
                          @if (seeMore || $index < 15) {
                            <div data-cypress="single-notification-full">
                              <div class="single-notification-container">
                                <div class="unread-dot" [hidden]="notification.read"></div>
                                <div class="single-notification-with-date">
                                  <div class="single-notification-content" [ngClass]="{unread: !notification.read}">
                                    <img
                                      [src]="notification.productLogo ? notification.productLogo : '../../assets/logo_deploy_cockpit.svg'"
                                      alt="{{ notification.productName }}"
                                      style="width: 30px; height: auto" />
                                      <div>
                                        @if (notification.productName) {
                                          <span class="single-notification-product-name"
                                            >{{ notification.productName }} :
                                          </span>
                                        }
                                        <span class="single-notification-text"><div [outerHTML]="notification.text | safeHtml"></div></span>
                                      </div>
                                    </div>
                                    <div>{{ getDateDiff(notification.date) }}</div>
                                  </div>
                                </div>
                                <div class="single-notification-actions-container">
                                  <div
                                    (click)="invertNotificationRead(notification)"
                                    (keydown)="$event.key == 'Enter' ? invertNotificationRead(notification) : null">
                                    Mark as {{ notification.read ? "unread" : "read" }}
                                  </div>
                                  <div class="actions-dot"></div>
                                  <div
                                    (click)="goToNotification(notification)"
                                    (keydown)="$event.key == 'Enter' ? goToNotification(notification) : null"
                                    data-cypress="Take a look">
                                    Take a look
                                  </div>
                                  <div class="actions-dot"></div>
                                  <div (click)="deleteNotification(notification)" (keydown)="$event.key == 'Enter' ? deleteNotification(notification) : null">
                                    Delete
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                      @if (!seeMore && notificationsToDisplay.length > 6) {
                        <div
                          (click)="seeMoreClicked()"
                          (keydown)="$event.key == 'Enter' ? seeMoreClicked() : null"
                          class="see-more-text">
                          See more
                        </div>
                      }
                    </div>
                  </ng-template>
                </li>
                @if (userHasRights()) {
                  <li class="nav-item">
                    <button class="btn btn-outline btn-circle" id="help-btn" [routerLink]="['/help']">
                      <span class="material-icons-outlined header-icon">help_outline</span>
                    </button>
                  </li>
                }
                <li class="nav-item">
                  <span class="navbar-text text-uppercase">{{ username }} </span>
                  <button class="btn btn-outline btn-circle" id="account-button" [matMenuTriggerFor]="popover.profileMenu">
                    <span class="material-icons-outlined header-icon">account_circle</span>
                  </button>
                  <app-popover #popover [isWriterRightsManagement]="isWriterRightsManagement" [canAddProduct]="canAddProduct" [canAddDataProduct]="canAddDataProduct" [canAddProgram]="canAddProgram" [canAddEnablerProject]="canAddEnablerProject"
                  [isAdmin]="isAdmin"></app-popover>
                </li>
                <li>
                  <img class="logo-totalenergies" src="/assets/Logo_TotalEnergies.svg" alt="totalenergies_logo" />
                </li>
              </ul>
            </div>
            <hr class="separator" />
            <div class="container-fluid nav-ct-container no-export">
              <!-- Tab menu -->
              <ul class="nav nav-tabs">
                @if (temporaryProduct) {
                  <li class="nav-item">
                    <a
                      class="nav-link active"
                      [routerLink]="[temporaryProduct.dataProduct ? '/data-product' : '/product', temporaryProduct.name, temporaryProduct.id]"
                      (click)="onProductSelect(temporaryProduct.id)">
                      {{ temporaryProduct.name }}
                    </a>
                  </li>
                }
                @if (temporaryEnablerProject) {
                  <li class="nav-item">
                    <a
                      class="nav-link active"
                      [routerLink]="['/enabler-project', temporaryEnablerProject.name, temporaryEnablerProject.id]"
                      (click)="onEnablerProjectSelect(temporaryEnablerProject)">
                      {{ temporaryEnablerProject.name }}
                    </a>
                  </li>
                }
                @for (product of userProducts; track product; let index = $index) {
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      [routerLink]="[product.dataProduct ? '/data-product' : '/product', product.name, product.id]"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{exact: true}"
                      (click)="onProductSelect(product.id)">
                      {{ product.name }}
                    </a>
                  </li>
                }
                @if (anyMonitoringAvailable() || isAdmin) {
                  <li class="nav-item" id="monitoring-nav">
                    <a
                      class="nav-link monitoring-link"
                      [ngClass]="isOnRoute('monitoring') || monitoringMenuOpened ? 'active' : ''"
                      (click)="monitoringMenuClicked()">
                      Monitoring</a
                      >
                      @if (monitoringMenuOpened) {
                        <div class="submenu">
                          @for (item of monitoringMenuItems | keyvalue; track item) {
                            <div>
                              <ng-container *ngTemplateOutlet="menuItem; context: {item: item, level: 0, parentPath: '', menuName: 'monitoring'}"></ng-container>
                            </div>
                          }
                        </div>
                      }
                    </li>
                  }
                  @if (anyRoadmapPreparationAvailable()) {
                    <li class="nav-item" id="roadmap-preparation-nav">
                      <a
                        class="nav-link"
                        [ngClass]="isOnRoute('roadmap-preparation') || roadmapPreparationMenuOpened ? 'active' : ''"
                        (click)="roadmapPreparationMenuClicked()">
                        Roadmap Prep.</a
                        >
                        @if (roadmapPreparationMenuOpened) {
                          <div class="submenu">
                            @for (item of roadmapPreparationMenuItems | keyvalue; track item) {
                              <div>
                                <ng-container *ngTemplateOutlet="menuItem; context: {item: item, level: 0, parentPath: '', menuName: 'roadmapPreparation'}"></ng-container>
                              </div>
                            }
                          </div>
                        }
                      </li>
                    }
                    @if (programs.length > 0 || isAdmin) {
                      <li class="nav-item" id="program-nav">
                        <a
                          class="nav-link"
                          [ngClass]="isOnRoute('program/') || programMenuOpened ? 'active' : ''"
              (click)="programMenuOpened = !programMenuOpened;
                branchMenuOpened = false;
                domainMenuOpened = false;
                organizationMenuOpened = false;
                enablerMenuOpened = false;
                closeMonitoring();
                !programMenuOpened ? closeProgram() : null">
                          Program</a
                          >
                          @if (programMenuOpened) {
                            <div class="submenu">
                              @for (program of programMenuItems | keyvalue; track program) {
                                <div>
                                  <ng-container
                                  *ngTemplateOutlet="menuItem; context: {item: program, level: 0, parentPath: 'program', menuName: 'program', disableClick: !!program.value.subItems, allowOpenIfOneItem: true}"></ng-container>
                                </div>
                              }
                            </div>
                          }
                        </li>
                      }
                      @if (enablerMenuItems) {
                        <li class="nav-item" id="enabler-nav">
                          <a
                            class="nav-link"
                            [ngClass]="isOnRoute('enabler/') || enablerMenuOpened ? 'active' : ''"
                            (click)="enablerMenuClicked()"
                          >Enabler</a>
                          @if (enablerMenuOpened) {
                            <div class="submenu">
                              @for (item of (enablerMenuItems | keyvalue); track item) {
                                <div>
                                  <ng-container *ngTemplateOutlet="menuItem; context: {item: item, level: 0, parentPath: '', menuName: 'enabler', disableClick: !!item.value.subItems}"></ng-container>
                                </div>
                              }
                            </div>
                          }
                        </li>
                      }
                      @if (hasAtLeastOnePortfolio(portfolioMenuItems)) {
                        @if (hasAtLeastOnePortfolio(portfolioMenuItems.Branch?.subItems) || isAdmin) {
                          <li class="nav-item" id="branch-nav">
                            <a
                              class="nav-link"
                              [ngClass]="isOnRoute('portfolio-review/Branch') || branchMenuOpened ? 'active' : ''"
                (click)="
                  branchMenuOpened = !branchMenuOpened;
                  domainMenuOpened = false;
                  organizationMenuOpened = false;
                  programMenuOpened = false;
                  enablerMenuOpened = false;
                  closeMonitoring();
                  !branchMenuOpened ? closeBranch() : null
                "
                              >Branch</a
                              >
                              @if (branchMenuOpened) {
                                <div class="submenu">
                                  @for (item of portfolioMenuItems.Branch?.subItems | keyvalue; track item) {
                                    <div>
                                      <ng-container
                                      *ngTemplateOutlet="menuItem; context: {item: item, level: 0, parentPath: 'Branch', menuName: 'portfolio'}"></ng-container>
                                    </div>
                                  }
                                </div>
                              }
                            </li>
                          }
                          @if (hasAtLeastOnePortfolio(portfolioMenuItems.Organization?.subItems) || isAdmin) {
                            <li class="nav-item" id="organization-nav">
                              <a
                                class="nav-link"
                                [ngClass]="isOnRoute('portfolio-review/Organization') || isOnRoute('digital-line') || organizationMenuOpened ? 'active' : ''"
                (click)="
                  organizationMenuOpened = !organizationMenuOpened;
                  branchMenuOpened = false;
                  domainMenuOpened = false;
                  programMenuOpened = false;
                  enablerMenuOpened = false;
                  closeMonitoring();
                  !organizationMenuOpened ? closeOrganization() : null
                "
                                >Organization</a
                                >
                                @if (organizationMenuOpened) {
                                  <div class="submenu">
                                    @for (item of portfolioMenuItems.Organization?.subItems | keyvalue; track item) {
                                      <div>
                                        <ng-container
                                        *ngTemplateOutlet="menuItem; context: {item: item, level: 0, parentPath: 'Organization', menuName: 'portfolio'}"></ng-container>
                                      </div>
                                    }
                                  </div>
                                }
                              </li>
                            }
                            @if (hasAtLeastOnePortfolio(portfolioMenuItems['Data Platform']?.subItems) || isAdmin) {
                              <li class="nav-item" id="data-platform-nav">
                                <a
                                  class="nav-link"
                                  [ngClass]="isOnRoute('portfolio-review/Data%20Platform') || dataPlatformMenuOpened ? 'active' : ''"
                (click)="
                  dataPlatformMenuOpened = !dataPlatformMenuOpened;
                  branchMenuOpened = false;
                  domainMenuOpened = false;
                  organizationMenuOpened = false;
                  programMenuOpened = false;
                  enablerMenuOpened = false;
                  closeMonitoring();
                  !dataPlatformMenuOpened ? closeDataPlatform() : null
                "
                                  >Data Platform</a
                                  >
                                  @if (dataPlatformMenuOpened) {
                                    <div class="submenu">
                                      @for (item of portfolioMenuItems['Data Platform']?.subItems | keyvalue; track item) {
                                        <div>
                                          <ng-container
                                          *ngTemplateOutlet="menuItem; context: {item: item, level: 0, parentPath: 'Data Platform', menuName: 'portfolio'}"></ng-container>
                                        </div>
                                      }
                                    </div>
                                  }
                                </li>
                              }
                              @if (hasAtLeastOnePortfolio(portfolioMenuItems.Domain?.subItems) || isAdmin) {
                                <li class="nav-item" id="domain-nav">
                                  <a
                                    class="nav-link"
                                    [ngClass]="isOnRoute('portfolio-review/Domain') || isOnRoute('portfolio-review/Discipline') || domainMenuOpened ? 'active' : ''"
                (click)="
                  domainMenuOpened = !domainMenuOpened;
                  branchMenuOpened = false;
                  organizationMenuOpened = false;
                  programMenuOpened = false;
                  enablerMenuOpened = false;
                  closeMonitoring();
                  !domainMenuOpened ? closeDomain() : null
                "
                                    >Domain</a
                                    >
                                    @if (domainMenuOpened) {
                                      <div class="submenu">
                                        @for (item of portfolioMenuItems.Domain?.subItems | keyvalue; track item) {
                                          <div>
                                            <ng-container
                                            *ngTemplateOutlet="menuItem; context: {item: item, level: 0, parentPath: 'Domain', menuName: 'portfolio'}"></ng-container>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </li>
                                }
                              }
                              @if (isReaderProduct || isReaderDataProduct || isReaderEnablerProject) {
                                <li class="nav-item">
                                  <a class="nav-link header-icon" [routerLink]="['/search']" routerLinkActive="active" (click)="emptyTemporaryProductAndEnablerProject()">
                                    <span class="material-icons-outlined">search</span>
                                    Search</a
                                    >
                                  </li>
                                }
                              </ul>
                            </div>
                          </div>
                        </div>
                      </nav>

                      <ng-template #menuItem let-item="item" let-level="level" let-parentPath="parentPath" let-menuName="menuName" let-disableClick="disableClick" let-allowOpenIfOneItem="allowOpenIfOneItem">
                        <div [ngStyle]="{'margin-left': item.value.subItems && (allowOpenIfOneItem || hasMoreThanOneSubItem(item.value.subItems)) ? 24 * level + 'px' : 24 * level + 32 + 'px'}">
                          <div class="item-header">
                            @if (item.value.subItems && (allowOpenIfOneItem || hasMoreThanOneSubItem(item.value.subItems))) {
                              <span
                                class="material-icons-outlined pointer"
                                (click)="itemClicked(menuName, item, level)"
                                (keydown)="itemClicked(menuName, item, level)">
                                {{ item.value.open ? "keyboard_arrow_down" : "keyboard_arrow_right" }}</span
                                >
                            }
                            <span
                              [class.portfolio-option]="!disableClick"
                              [class.pointer]="!disableClick"
                              [attr.data-cypress]="item.key"
                              (click)="!disableClick && selectMenuItem(menuName, parentPath, item.key, level, item)"
                              (keyup)="!disableClick && selectMenuItem(menuName, parentPath, item.key, level, item)"
                              >{{ item.key }} @if (item.value.subItems) {
                              <span>({{ getNumberOfSubItems(item.value) }})</span>
                              }</span
                              >
                            </div>
                            <div [hidden]="!item.value.open">
                              @for (subItem of item.value.subItems | keyvalue; track subItem) {
                                <div>
                                  <ng-container
          *ngTemplateOutlet="
            menuItem;
            context: {item: subItem, level: level + 1, parentPath: parentPath + '/' + item.key, menuName: menuName, disableClick: !!subItem.value.subItems, allowOpenIfOneItem: allowOpenIfOneItem}
          "></ng-container>
                                </div>
                              }
                            </div>
                          </div>
                        </ng-template>
